import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

const MonthlyViewNavigation = ({ date }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleViewChange = (_event, newView) => {
    if (newView) {
      navigate(`/chart/monthly/${newView}/${date}`);
    }
  };

  const currentView = location.pathname.split('/')[3] || 'overview';

  return (
    <Box sx={{ pt: 2 }}>
      <ToggleButtonGroup
        value={currentView}
        exclusive
        onChange={handleViewChange}
        orientation="vertical"
        sx={{
          width: '100%',
          '& .MuiToggleButton-root': {
            justifyContent: 'flex-start',
            textTransform: 'none',
            border: 'none',
            borderRadius: 0,
            '&.Mui-selected': {
              backgroundColor: 'action.selected',
              borderColor: 'primary.main',
            }
          }
        }}
      >
        <ToggleButton value="overview">{t("monthly.nav.overview")}</ToggleButton>
        <ToggleButton value="plannings">{t("monthly.nav.operations")}</ToggleButton>
        <ToggleButton value="hours-worked">{t("monthly.nav.worktime")}</ToggleButton>
        <ToggleButton value="oee">{t("monthly.nav.oee")}</ToggleButton>
        <ToggleButton value="throughput-per-hour">{t("monthly.nav.throughputPerHour")}</ToggleButton>
        <ToggleButton value="workcell-schedule">{t("monthly.nav.workcellActivity")}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default MonthlyViewNavigation;
